<template>
  <el-container class="container">
    <left-menu />
    <el-container direction="vertical">
      <el-container direction="vertical" class="main_container">
        <router-view :key="$route.fullPath" />
      </el-container>
    </el-container>
  </el-container>
</template>
<script>
import { mapActions } from "vuex";
import LeftMenu from "@/components/public/LeftMenu.vue";
export default {
  components: {
    "left-menu": LeftMenu
  },
  data() {
    return {
      laoding: true
    };
  },
  created() {
    this.getDicts();
  },
  methods: {
    ...mapActions(["getDicts"])
  }
};
</script>
